import React from 'react';
import Hero from './Hero.jsx';
import FeaturedServices from './FeaturedServices.jsx';
import About from './About.jsx';
import Stats from './Stats.jsx';
import Services from './Services.jsx';
import Portfolio from './Portfolio.jsx';
import Testimonials from './Testimonials.jsx';
import CallToAction from './CallToAction.jsx';
import Team from './Team.jsx';
import Contact from './Contact.jsx';

const Home = () => {
  return (
    <main className="main">
      <Hero />
      <FeaturedServices />
      <About />
      <Stats />
      <Services />
      <Portfolio />
      <Testimonials />
      <CallToAction />
      <Team />
      <Contact />
    </main>
  );
};

export default Home;

